<template>
  <div class='Fuell-Overlay'>
    <div class='Fuell-Modal'>
      <div class='Fuell-Modal--window centered'>
        <button
          class='Fuell-Modal--close-button'
          @click="closeModal"
        >
          <img
            :src="require('@/assets/img/icons/close.svg')"
            alt='close'
          >
        </button>
        <h3 class='Fuell-Modal--title'>{{edit ? $t('transaction_without_receipt_edit_note'): $t('transactions_funnel_reject_reason_modal_title')}}</h3>

        <div class="d-flex flex-column justify-content-between">
          <span class="Fuell-Text text-center"> {{$t('transactions_not_receipt_reason_modal_message')}}</span>
          <div class="d-flex flex-column mt-3">
            <textarea
              :placeholder="$t('transactions_not_receipt_reason_modal_placeholder')"
              v-model="notReceiptReason"
              @blur="$v.notReceiptReason.$touch()"
              class="Input-textarea"
            ></textarea>
            <button
              class="Fuell-Button blue mt-4"
              @click="emitNotReceiptReason"
              :disabled="$v.$invalid"
              :class="{'disabled' : $v.$invalid}"
            > <span class="Fuell-Button--label mx-auto">{{$t('ACTION_SEND')}} </span></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'

export default {
  name: 'TransactionNotReceiptModal',
  mixins: [validationMixin, _modalHandlerMixin],
  props: {
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      notReceiptReason: ''
    }
  },
  methods: {
    emitNotReceiptReason () {
      this.$emit('emitNotReceiptReason', this.notReceiptReason)
      this.closeModal()
    }
  },
  validations: {
    notReceiptReason: {
      required
    }
  }
}

</script>

<style scoped>
.Fuell-Modal--window {
  max-width: 412px !important;
  width: 100%;
  padding: 24px;
  overflow: hidden !important;
}
.Fuell-Overlay {
  z-index: 20000 !important;
}
.Input-textarea {
  height: 94px !important;
}

textarea::placeholder {
  color: var(--fill-text-area);
  padding: 5px 10px;
}
.disabled {
  background-color: var(--action-disabled);
  color: var(--text-disabled);
  -webkit-text-fill-color:var(--text-disabled);
  opacity:1;
}
</style>
